import { css } from 'styled-components';

// Define SVG paths for icons
const SVG_PATHS = {
  USER: 'M13.6875 13C14.8125 11.8438 15.5 10.25 15.5 8.5C15.5 4.9375 12.5625 2 9 2C5.40625 2 2.5 4.9375 2.5 8.5C2.5 10.25 3.15625 11.8438 4.28125 13C4.875 11.5312 6.3125 10.5 8 10.5H10C11.6562 10.5 13.0938 11.5312 13.6875 13ZM12.4375 14.0312C12.2188 12.875 11.1875 12 10 12H8C6.78125 12 5.75 12.875 5.53125 14.0312C6.53125 14.6562 7.71875 15 9 15C10.25 15 11.4375 14.6562 12.4375 14.0312ZM9 16.5C6.125 16.5 3.5 15 2.0625 12.5C0.625 10.0312 0.625 7 2.0625 4.5C3.5 2.03125 6.125 0.5 9 0.5C11.8438 0.5 14.4688 2.03125 15.9062 4.5C17.3438 7 17.3438 10.0312 15.9062 12.5C14.4688 15 11.8438 16.5 9 16.5ZM9 8C9.4375 8 9.84375 7.78125 10.0625 7.375C10.2812 7 10.2812 6.53125 10.0625 6.125C9.84375 5.75 9.4375 5.5 9 5.5C8.53125 5.5 8.125 5.75 7.90625 6.125C7.6875 6.53125 7.6875 7 7.90625 7.375C8.125 7.78125 8.53125 8 9 8ZM6.25 6.75C6.25 5.78125 6.75 4.875 7.625 4.375C8.46875 3.90625 9.5 3.90625 10.375 4.375C11.2188 4.875 11.75 5.78125 11.75 6.75C11.75 7.75 11.2188 8.65625 10.375 9.15625C9.5 9.625 8.46875 9.625 7.625 9.15625C6.75 8.65625 6.25 7.75 6.25 6.75Z',
  PASSWORD:
    'M6.5 6C6.5 6.34375 6.53125 6.65625 6.59375 6.96875C6.65625 7.21875 6.59375 7.46875 6.40625 7.65625L1.5 12.5625V15H3.5V13.75C3.5 13.3438 3.8125 13 4.25 13H5.5V11.75C5.5 11.3438 5.8125 11 6.25 11H7.9375L8.84375 10.0938C9.03125 9.90625 9.28125 9.84375 9.53125 9.90625C9.84375 9.96875 10.1562 10 10.5 10C12.6875 10 14.5 8.21875 14.5 6C14.5 3.8125 12.6875 2 10.5 2C8.28125 2 6.5 3.8125 6.5 6ZM10.5 0.5C13.5312 0.5 16 2.96875 16 6C16 9.0625 13.5312 11.5 10.5 11.5C10.1875 11.5 9.90625 11.5 9.625 11.4375L8.78125 12.2812C8.625 12.4375 8.4375 12.5 8.25 12.5H7V13.75C7 14.1875 6.65625 14.5 6.25 14.5H5V15.75C5 16.1875 4.65625 16.5 4.25 16.5H0.75C0.3125 16.5 0 16.1875 0 15.75V12.25C0 12.0625 0.0625 11.875 0.21875 11.7188L5.0625 6.875C5 6.59375 5 6.3125 5 6C5 2.96875 7.4375 0.5 10.5 0.5ZM11.5 6C10.9375 6 10.5 5.5625 10.5 5C10.5 4.46875 10.9375 4 11.5 4C12.0312 4 12.5 4.46875 12.5 5C12.5 5.5625 12.0312 6 11.5 6Z',
  IP: 'M10.4688 13.5C10.75 12.9375 11 12.2812 11.1562 11.5312H9.5L9.9375 10.0312H11.4062C11.4688 9.53125 11.5 9.03125 11.5 8.53125C11.5 8 11.4688 7.5 11.4062 7.03125H6.5625C6.53125 7.28125 6.53125 7.5625 6.5 7.84375L5 8.28125C5 7.84375 5.03125 7.4375 5.0625 7H2.65625C2.5625 7.5 2.5 8 2.5 8.5C2.5 8.6875 2.5 8.84375 2.5 9.03125L1.03125 9.46875C1 9.15625 1 8.84375 1 8.5C1 4.09375 4.5625 0.5 9 0.5C13.4062 0.5 17 4.09375 17 8.53125C17 12.9375 13.4062 16.5312 9 16.5312C8.65625 16.5312 8.34375 16.5 8.03125 16.4688L8.53125 14.8438C8.71875 14.9688 8.875 15 9 15C9.21875 15 9.84375 14.7812 10.4688 13.5ZM7.5 3.53125C7.21875 4.09375 7 4.75 6.8125 5.5H11.1562C11 4.75 10.75 4.09375 10.4688 3.53125C9.84375 2.25 9.21875 2 9 2C8.75 2 8.15625 2.25 7.5 3.53125ZM13 8.5C13 9.03125 12.9688 9.53125 12.9062 10H15.3125C15.4375 9.53125 15.5 9.03125 15.5 8.5C15.5 8 15.4375 7.5 15.3125 7H12.9062C12.9688 7.5 13 8 13 8.5ZM12.6875 5.5H14.75C14.0938 4.21875 13 3.1875 11.6875 2.59375C12.125 3.40625 12.4688 4.40625 12.6875 5.5ZM3.21875 5.5H5.28125C5.5 4.40625 5.84375 3.40625 6.28125 2.59375C4.96875 3.1875 3.875 4.21875 3.21875 5.5ZM12.6875 11.5C12.4688 12.625 12.125 13.625 11.6875 14.4375C13 13.8438 14.0938 12.8125 14.75 11.5H12.6875ZM2.21875 10.1562L8.59375 8.28125C9 8.15625 9.34375 8.53125 9.21875 8.90625L7.34375 15.3125C7.21875 15.7188 6.625 15.7812 6.40625 15.375L5.53125 13.5938C5.5 13.5312 5.46875 13.5 5.4375 13.4688L2.6875 16.2188C2.3125 16.625 1.65625 16.625 1.28125 16.2188C0.875 15.8438 0.875 15.1875 1.28125 14.8125L4.03125 12.0625C4 12.0312 3.96875 12 3.90625 11.9688L2.125 11.0938C1.71875 10.875 1.78125 10.2812 2.21875 10.1562Z',
  CONNECTION:
    'M11.5 3C11.5 3.5625 11.9375 4 12.5 4C13.0312 4 13.5 3.5625 13.5 3C13.5 2.46875 13.0312 2 12.5 2C11.9375 2 11.5 2.46875 11.5 3ZM10.5625 4.59375L4.96875 6.8125C4.96875 6.875 5 6.9375 5 7C5 7.375 4.90625 7.71875 4.78125 8.03125L9.1875 11.875C9.46875 11.6875 9.8125 11.5625 10.1875 11.5312L11.3125 5.21875C11.0312 5.0625 10.75 4.84375 10.5625 4.59375ZM12.8125 5.5L11.6562 11.8125C12.4375 12.2188 13 13.0625 13 14C13 15.4062 11.875 16.5 10.5 16.5C9.09375 16.5 8 15.4062 8 14C8 13.6562 8.0625 13.3125 8.1875 13L3.78125 9.15625C3.40625 9.375 2.96875 9.5 2.5 9.5C1.09375 9.5 0 8.40625 0 7C0 5.625 1.09375 4.5 2.5 4.5C3.28125 4.5 3.96875 4.875 4.40625 5.4375L10 3.21875C10 3.15625 10 3.0625 10 3C10 1.625 11.0938 0.5 12.5 0.5C13.875 0.5 15 1.625 15 3C15 4.28125 14.0312 5.34375 12.8125 5.5ZM9.5 14C9.5 14.5625 9.9375 15 10.5 15C11.0312 15 11.5 14.5625 11.5 14C11.5 13.4688 11.0312 13 10.5 13C9.9375 13 9.5 13.4688 9.5 14ZM2.5 6C1.9375 6 1.5 6.46875 1.5 7C1.5 7.5625 1.9375 8 2.5 8C3.03125 8 3.5 7.5625 3.5 7C3.5 6.46875 3.03125 6 2.5 6Z',
};

// Helper function to create SVG data URL
const createSvgDataUrl = (svgPath: string, color: string): string => {
  // Properly encode the path and color for data URL
  const encodedPath = svgPath.replace(/\s+/g, '%20');
  const encodedColor = color.replace('#', '%23');

  return `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 17'%3E%3Cpath fill='${encodedColor}' d='${encodedPath}'/%3E%3C/svg%3E")`;
};

export const getCredentialsCardStylesAsString = (isDarkMode: boolean): string => {
  // Define colors once
  const iconColor = isDarkMode ? '#719CF9' : '#1153E4';

  return `
  --credentials-card-connection-ssh-bg: ${isDarkMode ? '#151C2B' : '#EEEFF2'};
  --credentials-card-connection-ssh-text: ${isDarkMode ? '#FFBB45' : '#EB0037'};
  --credentials-card-text-colour: ${isDarkMode ? '#F9F9FB' : '#151C2B'};
  --credentials-card-text-colour-light: ${isDarkMode ? '#EEEFF2' : '#525A6A'};
  --credentials-card-background: ${isDarkMode ? '#212C42' : '#F9F9FB'};
  --credentials-card-icon-color: ${iconColor};

  .credentials-card {
    border-radius: 8px;
    padding: 24px;
    margin: 10px 0;
    width: 100%;
    background-color: var(--credentials-card-background, #F9F9FB);
    color: var(--text-color);
    box-sizing: border-box;
  }

  .credentials-card .credentials-card-title {
    font-family: 'Ubuntu', sans-serif;
    margin: 0;
    font-size: 24px;
    font-weight: 500;
    color: var(--credentials-card-text-colour, #151C2B) !important;
  }

  .credentials-card .credentials-card-subtitle {
    margin: 10px 0 28px 0;
    font-size: 16px;
    color: var(--credentials-card-text-colour, #151C2B) !important  ;
  }

  .credentials-card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    box-sizing: border-box;
  }

  .credentials-card-item {
    margin-bottom: 2px;
    width: fit-content;
    min-width: 180px;
    box-sizing: border-box;
  }

  .credentials-card-item.password {
    min-width: 155px;
  }

  .credentials-card-item.ip {
    min-width: 177px;
  }

  .credentials-card-item.connection {
    min-width: 313px;
  }

  .credentials-card-label {
    font-size: 16px;
    color: var(--credentials-card-text-colour-light, #525A6A);
    opacity: 0.7;
    margin-bottom: 4px;
    font-weight: 400;
  }

  .credentials-card-value-container {
    display: flex;
    align-items: center;
    font-weight: 600;
  }

  .credentials-card-value {
    font-size: 20px;
    color: var(--credentials-card-text-colour, #151C2B);
    margin-right: 8px;
  }

  .credentials-connection-code {
    display: inline-flex;
    align-items: center;
    background-color: var(--credentials-card-connection-ssh-bg, #EEEFF2);
    padding: 4px 8px;
    border-radius: 4px;
    flex-shrink: 0;
    margin-right: 12px;
    font-family: 'Source Sans Pro', monospace;
  }

  .credentials-connection-command {
    color: var(--credentials-card-connection-ssh-text, #eb0037);
    font-size: 16px;
  }

  .credentials-icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    text-align: center;
    font-family: "Font Awesome 6 Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px; /* 118.75% */
  }

  .credentials-icon-user {
    background-image: ${createSvgDataUrl(SVG_PATHS.USER, iconColor)};
  }

  .credentials-icon-password {
    background-image: ${createSvgDataUrl(SVG_PATHS.PASSWORD, iconColor)};
  }

  .credentials-icon-ip {
    background-image: ${createSvgDataUrl(SVG_PATHS.IP, iconColor)};
  }

  .credentials-icon-connection {
    background-image: ${createSvgDataUrl(SVG_PATHS.CONNECTION, iconColor)};
  }

  .copy-wrapper {
    position: relative;
    align-items: center;
  }
  .copy-button {
    width: 30px;
    height: 30px;
    background: none;
    border: none;
    cursor: pointer;
    margin-left: 2px;
    padding: 8px;
    color: var(--credentials-card-text-colour, #151c2b);
    opacity: 0;
    transition: opacity 0.2s ease, background-color 0.2s ease;
    display: inline-flex;
    background-image: url(https://tryhackme-images.s3.amazonaws.com/user-uploads/669f9c2881a4b22e53bd3b59/room-content/669f9c2881a4b22e53bd3b59-1746018732277.svg);
    background-repeat: no-repeat;
    background-position: center;
  }

  .copy-wrapper:hover .copy-button {
    opacity: 1;
  }

  .copy-button:hover {
    background-color: #fff;
    border: 1px solid #d4d8df;
    border-radius: 4px;
  }

  .tooltip {
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    background: #fff;
    color: #151c2b;
    padding: 12px;
    gap: 12px;
    border-radius: 5px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    margin-left: 6px;
    height: 40px;
    box-shadow: rgb(98 110 133 / 57%) 0px 3px 13px 0px;
    z-index: 999;
  }

  .tooltip::before {
    content: 'Copy';
    display: block;
  }

  .tooltip::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: transparent #ffffff transparent transparent;
    box-shadow: 0px 3px 13px 0px #151c2b12;
  }

  .copy-button:hover + .tooltip,
  .tooltip:hover {
    opacity: 1;
  }

  .copy-wrapper.show-tooltip .tooltip {
    opacity: 1;
  }

  .copy-wrapper.show-tooltip .tooltip::before {
    content: '✓ Copied';
  }
`;
};

export const CredentialsCardStyles = css<{ $isDarkMode: boolean }>`
  ${({ $isDarkMode }) => getCredentialsCardStylesAsString($isDarkMode)}
`;
